import React from 'react';
// import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { BrowserRouter, Link, Switch } from 'react-router-dom';
import { createLogger } from 'redux-logger';
import toastr from 'toastr';
import registerServiceWorker from './registerServiceWorker';
import reducer from './reducers';
import callAPIMiddleware from './middleware/callAPIMiddleware';
import NotFound from './components/layouts/NotFoundComponent';
import PrivateRoute from './components/routes/PrivateRoute';
import PublicRoute from './components/routes/PublicRoute';
import './assets/scss/common.css';
import img from './assets/images/Raseel_Logomark.jpg';
import img2 from './assets/images/favicon.ico';
import 'toastr/build/toastr.min.css';
import { ROUTE } from './config';
import Login from './containers/Login';
import Env from './utility/env';
import { createRoot } from 'react-dom/client';

/*Handling events with React elements is very similar to handling events on DOM elements
* Inside a loop it is common to want to pass an extra parameter to an event handler.
*the e argument representing the React event will be passed as a second argument after the ID. 
*With an arrow function, we have to pass it explicitly, 
*but with bind any further arguments are automatically forwarded
*The bind() method creates a new function that, when called, has its this keyword set to the provided value
*An arrow function expression has a shorter syntax than a function expression and does not have its own this, arguments, super, or new.target
*/
const dir = localStorage.getItem('language') == "ar" ? "rtl" : "ltr";
const rootElement = document.getElementsByTagName( 'html' )[0];
rootElement.setAttribute('dir', `${dir}`);

const country = Env.getEnv("COUNTRY");
localStorage.setItem("country",country)

function getFaviconEl() {
    return document.getElementById("favicon");
  }

const favicon = getFaviconEl(); // Accessing favicon element
if(localStorage.getItem('country')=="sa" ){
    favicon.href=img;
}else{
    favicon.href=img2;
}
   
const middleware = [thunk, callAPIMiddleware];
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
if (process.env.NODE_ENV !== 'production') {
    middleware.push(createLogger());
}

toastr.options.timeOut = 3000;
toastr.options.extendedTimeOut = 3500;

const setRoutes = () => {
    const route = ROUTE;
    return route.map((eachRoute, index) => {
        if (eachRoute.private === true) {
            return <PrivateRoute key={index} path={eachRoute.path} meta={eachRoute.meta} exact={eachRoute.exact} path={eachRoute.path} section={eachRoute.component} component={eachRoute.component} permission={eachRoute.permission} />;
        } else {
            return <PublicRoute key={index} path={eachRoute.path} meta={eachRoute.meta} exact={eachRoute.exact} path={eachRoute.path} section={eachRoute.component} component={eachRoute.component}/>;
        }
    });

}
const store = createStore(reducer, composeEnhancers(applyMiddleware(...middleware)));

// Use `ReactDOM.createRoot` for React 18
const root = createRoot(document.getElementById('root'));

root.render(
    <Provider store={store}>
        <BrowserRouter basename={Env.getEnv('REACT_APP_HOMEPAGE')}>
            <Switch>
                {setRoutes()}
                <PublicRoute exact path='/login' component={Login} />
                <PublicRoute component={NotFound} />
            </Switch>
        </BrowserRouter>
    </Provider>
);

registerServiceWorker();